import { render, staticRenderFns } from "./ItensOrcamento.vue?vue&type=template&id=3a6b14c3&scoped=true"
import script from "./ItensOrcamento.vue?vue&type=script&lang=js"
export * from "./ItensOrcamento.vue?vue&type=script&lang=js"
import style0 from "./ItensOrcamento.vue?vue&type=style&index=0&id=3a6b14c3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a6b14c3",
  null
  
)

export default component.exports